export default __webpack_public_path__ + "static/media/3031 spice rack F top.03c2597a.png";